"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThumbUp = function ThumbUp(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M8 10H6V18H8V10Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.8333 13C16.8333 12.7348 16.728 12.4804 16.5404 12.2929C16.3529 12.1054 16.0986 12 15.8333 12C16.0986 12 16.3529 11.8946 16.5404 11.7071C16.728 11.5196 16.8333 11.2652 16.8333 11C16.8333 10.7348 16.728 10.4804 16.5404 10.2929C16.3529 10.1054 16.0986 10 15.8333 10H14V6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4V6C12 7.06087 11.5786 8.07828 10.8284 8.82843C10.0783 9.57857 9.06087 10 8 10V17H9.10156C9.27697 17.3041 9.52938 17.5566 9.83339 17.7322C10.1374 17.9077 10.4823 18.0001 10.8333 18H15.8333C16.0986 18 16.3529 17.8946 16.5404 17.7071C16.728 17.5196 16.8333 17.2652 16.8333 17C16.8333 16.7348 16.728 16.4804 16.5404 16.2929C16.3529 16.1054 16.0986 16 15.8333 16C16.0986 16 16.3529 15.8946 16.5404 15.7071C16.728 15.5196 16.8333 15.2652 16.8333 15C16.8333 14.7348 16.728 14.4804 16.5404 14.2929C16.3529 14.1054 16.0986 14 15.8333 14C16.0986 14 16.3529 13.8946 16.5404 13.7071C16.728 13.5196 16.8333 13.2652 16.8333 13Z",
    fill: props.foregroundColor
  }));
};

ThumbUp.defaultProps = {
  altText: "Thumb Up",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
ThumbUp.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = ThumbUp;
exports.default = _default;